import { Mail, CircleUserRound } from 'lucide-react';

/**
 * The floating pill tab bar for the two top-level places: your letters and
 * your profile. Deeper screens (a thread, a letter) keep their own bottom bar.
 */
export function TabBar({
  active,
  onLetters,
  onProfile,
}: {
  active: 'letters' | 'profile';
  onLetters: () => void;
  onProfile: () => void;
}) {
  return (
    <nav className="tab-bar" aria-label="Main">
      <button
        type="button"
        className={`tab-bar__tab${active === 'letters' ? ' tab-bar__tab--on' : ''}`}
        aria-current={active === 'letters' ? 'page' : undefined}
        onClick={onLetters}
      >
        <Mail size={20} aria-hidden="true" />
        <span className="visually-hidden">Letters</span>
      </button>
      <button
        type="button"
        className={`tab-bar__tab${active === 'profile' ? ' tab-bar__tab--on' : ''}`}
        aria-current={active === 'profile' ? 'page' : undefined}
        onClick={onProfile}
      >
        <CircleUserRound size={20} aria-hidden="true" />
        <span className="visually-hidden">Profile</span>
      </button>
    </nav>
  );
}
